import ArrayHelper from "utils/ArrayHelper"

const { max } = Math

const DEFAULT_SYMBOL_COUNT = 5

//anticipate wins on the following symbols
const SYMBOL_ANTICIPATION_LIST = ["H1", "H2", "H3", "M4", "M5", "M6", "L7", "L8", "L9", "L10"]

const SPIN_DURATION = 500
const SHORT_SPIN_DURATION = 250
const LONG_SPIN_DURATION = 750
const EXTENDED_SPIN_DURATION = 1500

const SYMBOL_ANTICIPATION_DURATIONS = [
    EXTENDED_SPIN_DURATION, //H1
    EXTENDED_SPIN_DURATION, //H2
    EXTENDED_SPIN_DURATION, //H3
    LONG_SPIN_DURATION, //M4
    LONG_SPIN_DURATION, //M5
    LONG_SPIN_DURATION, //M6
    SPIN_DURATION, //L7
    SPIN_DURATION, //L8
    SPIN_DURATION, //L9
    SPIN_DURATION //L10
]

function getPotentialWinningLines(props, symbol) {
    const { reelsConfig, currentSpinData } = props
    const { paylines, paytable } = reelsConfig
    const { symbols } = currentSpinData

     //convert paylines to booleans of whether we have the selected symbol
    const potentialWinningSymbols = paylines.map((line) => {
        let previous = true
        return line.map((symbolIndex, reelIndex) => {
            const reelSymbol = symbols[reelIndex][symbolIndex]
            const isMatch = (reelSymbol === symbol || reelSymbol === "WR")
            const isConnected = isMatch && previous
            previous = isMatch
            return isConnected
        })
    })

    //find the first paytable entry for the current symbol
    const symbolPayout = paytable.find((paytableEntry) => {
        return (paytableEntry.symbol === symbol)
    })

    const triggerIndex = symbolPayout.n - 1 //how many of these symbols do we need to trigger anticipation

    //find all the lines with the triggering number of symbols
    return potentialWinningSymbols.filter((winningSymbols) => {
        let connectedCount = 0
        for (let i = 0, l = winningSymbols.length; i < l; i++) {
            if (!winningSymbols[i]) {
                break
            }
            connectedCount++
        }
        return connectedCount >= triggerIndex
    })
}

export function calculateSpinDurations(props) {
    const potentialLines = SYMBOL_ANTICIPATION_LIST.map((symbol, index) => {
        const lines = getPotentialWinningLines(props, symbol)

        let connectedCount = 0
        return lines.reduce((longest, line) => {
            const connected = ArrayHelper(line).count(true)

            if (connected < connectedCount) {
                return longest
            }

            connectedCount = connected
            return line
        }, lines[0])
    })

    let anticipationDurations
    for (let i = 0, l = potentialLines.length; i < l; i++) {
        const line = potentialLines[i]

        if (line && line.length) {
            anticipationDurations = line.map((symbol, index) => {
                if (index > 1 && line[index - 1]) {
                    return SYMBOL_ANTICIPATION_DURATIONS[i]
                } else {
                    if (index < 2) {
                        return SPIN_DURATION
                    }
                    return SHORT_SPIN_DURATION
                }
            })
            break
        }
    }

    const durations = [SPIN_DURATION]
    for (let i = 1; i < 5; i++) {
        const next = anticipationDurations ? anticipationDurations[i] : (i < 3 ? SPIN_DURATION : SHORT_SPIN_DURATION)
        durations[i] = durations[i - 1] + next
    }
    return durations
}

export function getDefaultSpinDurations() {
    const durations = [SPIN_DURATION]
    for (let i = 1; i < 5; i++) {
        const next = (i < 3 ? SPIN_DURATION : SHORT_SPIN_DURATION)
        durations[i] = durations[i - 1] + next
    }
    return durations
}

export function calculateAnticipation(props) {
    //TODO: add more anticipation for high value symbols, scatters, and possibly reels following wild reels
    return getDefaultAnticipation()
}

export function getDefaultAnticipation() {
    return new Array(5).fill(DEFAULT_SYMBOL_COUNT)
}
